<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title>Projects Master</mat-card-title>
     

    <button mat-fab [ngClass]="isAdminGroupUser ? 'mat-mini-fab mat-accent' : 'mat-mini-fab mat-button-disabled'"
      (click)="openDialog()" matTooltip="Add TSI Project"
      style="position:absolute; right:10px;top:8px;width:35px; height:35px;">
      <span class="mat-mdc-button-wrapper">
        <i class="material-icons" style="font-size:30px;">add</i>
      </span>
    </button>
    <button mat-fab (click)="downloadAllRecords()" color="accent"
      style="position:absolute; right:60px;top:8px;width:35px; height:35px;"
      *ngIf="projects != null && projects.length >0" matTooltip="Download Records">
      <span class="mat-mdc-button-wrapper">
        <i class="material-icons" style="font-size:30px;">download</i>
      </span>
    </button>
    <mat-card-subtitle></mat-card-subtitle>
    <div class="row">
      <div class="col-md-9">
      </div>
      <div class="col-md-3">
        <mat-form-field *ngIf="projects!=null && projects.length >0">
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Search columns" #input>
        </mat-form-field>
      </div>
    </div>
    <mat-card-content>
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort
        (matSortChange)="announceSortChange($event)" *ngIf="projects != null && projects.length >0" 
         aria-label="Table listing projects" >

        <ng-container matColumnDef="icon">
          <th mat-header-cell *matHeaderCellDef>S No. </th>
          <td mat-cell *matCellDef="let element; let i = index;"> 
            {{ (i + 1) + ((pageEvent?.pageSize || paginator.pageSize) * (pageEvent?.pageIndex || paginator.pageIndex)) }}
          </td>
        </ng-container>
        <!-- brandId Column not visible -->
        <ng-container matColumnDef="invProjectId">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element; let i=index;"> {{element.invProjectId}} </td>
        </ng-container>

        <!-- brandName Column -->
        <ng-container matColumnDef="projectName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by projectName"> Project
            Name
          </th>
          <td mat-cell *matCellDef="let element"> {{element.projectName}} </td>
        </ng-container>

        <!-- description Column -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by description"> Description
          </th>
          <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>

        <!-- isDeleted Column -->
        <ng-container matColumnDef="isDeleted">
          <th mat-header-cell *matHeaderCellDef> Deleted </th>
          <td mat-cell *matCellDef="let element"> {{element.isDeleted}} </td>
        </ng-container>

        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef> Edit </th>
          <td mat-cell *matCellDef="let element">
            <button mat-mini-fab aria-label="Edit" [disabled]="!isAdminGroupUser"
              (click)="updateProject($event, element)">
              <mat-icon>create</mat-icon>
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef> Delete </th>
          <td mat-cell *matCellDef="let element">
            <button mat-mini-fab aria-label="Delete" [disabled]="!isAdminGroupUser"
              (click)="softDelete($event, element)" color="warn">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator
        [length]="totalRows"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="pageEvent = $event; pageChanged($event)">
     </mat-paginator>
      <div *ngIf="isLoaderResult" class="custSpinner">
      </div>
    </mat-card-content>
  </mat-card>
</div>